<div
    *appWaitUntilLoaded="resultMd"
    class="prose max-w-none"
    [innerHTML]="resultMd | safeHtml"
></div>
